import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=0db371f9&scoped=true&"
import script from "./clock.vue?vue&type=script&lang=js&"
export * from "./clock.vue?vue&type=script&lang=js&"
import style0 from "./clock.vue?vue&type=style&index=0&id=0db371f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db371f9",
  null
  
)

export default component.exports